<template>
  <div class="news-page">
    <LayoutDefault
      isShowHeader
      title="Новости"
    >
      <TheToolbar
        @click-plus="goToEditor(0)"
        @click-trash="deleteNews"
        @click-copy="cloneNews"
        :selected-row-table="selectedRowTableId"
        buttons
      />
      <ListTable
        :data="dataSource"
        :policies="cutPolicies(policies, 'Articles')"
        header-html
        @row-selected="onRowSelect"
        @redirect-to-editor="goToEditor"
        @row-edit="onRowEditSave"
      />
    </LayoutDefault>
  </div>
</template>

<script>
import { onMounted, computed, ref } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'

import LayoutDefault from '@/layout/LayoutDefault.vue'
import TheToolbar from '@/components/blocks/TheToolbar.vue'
import ListTable from '@/components/blocks/ListTable.vue'

import { cutPolicies } from '@/helpers/policiesValidator.js'

export default {
  name: 'NewsView',
  components: {
    LayoutDefault,
    ListTable,
    TheToolbar
  },
  setup () {
    const store = useStore()

    onMounted(() => {
      // запрашиваем данные при монтировании компонента
      store.dispatch('setNewsDataTable')
    })

    const policies = computed(() => store.getters.getPolicies)

    const dataSource = computed(() => {
      // данные для отрисовки таблицы
      return store.getters.getNewsDataTable
    })

    const selectedRowTableId = ref(0) // id товара по выбранной строке в таблице

    const onRowSelect = (e) => {
      // функция слушает событие выбора строки в таблице
      // получает id товара
      selectedRowTableId.value = e.data.Id
    }

    const goToEditor = (id) => {
      // переход на страницу редактора
      // если передать 0 то пустая форма
      router.push(`/news/editor/${id}`)
    }

    const deleteNews = () => {
      // инициирует запрос на удаление новости
      store.dispatch('setDeleteNews', selectedRowTableId.value)
    }

    const cloneNews = () => {
      // инициирует запрос на клонирование товара
      store.dispatch('setCloneNews', selectedRowTableId.value)
    }

    const onRowEditSave = (event) => {
      // при редактировании строки таблицы на предмет публикации
      // и готовности к публикации
      const obj = {
        ReadyToPublishStatus: event.newData.ReadyToPublish,
        PublishedStatus: event.newData.Published,
        Id: event.newData.Id
      }
      store.dispatch('setStatusNewsTable', obj)

      // а это чтобы в таблице сразу менялись данные не дожидаясь выполнения запроса
      const { newData, index } = event
      dataSource.value[index] = newData
    }

    return {
      dataSource,
      policies,
      cutPolicies,
      selectedRowTableId,
      onRowSelect,
      goToEditor,
      deleteNews,
      cloneNews,
      onRowEditSave
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
